import info from "@/assets/ts/onboarding/steps/info";
import types from "@/assets/ts/onboarding/steps/types";
import questions from "@/assets/ts/onboarding/steps/questions";

const form =
  {
      info,
      types,
      questions
  }

export default form
